import React, {useContext} from 'react';
import NavbartopView from './NavbartopView';
import {logout} from '../../services/MadricService';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../Context/MadricContext';

/**
 * La logique de la navBar
 * @return {JSX}
 */
function Navbartop() {
  const navigate = useNavigate();
  const {setConnUser} = useContext(MadricContext);

  /**
   * Permet de se déconnecter
   * @param {*} event event
   */
  async function handleLogout(event) {
    await logout().then((res) => {
      setConnUser({id: '', name: '', email: '', is_Admin: 0});
    });
  }

  /**
   * Navigue vers la section profile
   */
  function navigateAdministration() {
    navigate('/administration');
  }

  /**
   * Navigue vers l'accueil
   */
  function navigateAccueil() {
    navigate('/');
  }

  /**
   * Navigue vers la liste des chantiers
   */
  function navigateChantier() {
    navigate('/chantier');
  }

  /**
   * Navigue vers l'historique
   */
  function navigateHistorique() {
    navigate('/InfoGlobal');
  }

  /**
   * Navigue vers l'ajout de photos
   */
  function navigateAjouter() {
    navigate('/AjoutInfo');
  }

  /**
   * Navigue vers les checkins
   */
  function navigateCheckin() {
    navigate('/Checkin');
  }

  /**
   * Navigue vers le login
   */
  function navigateLogin() {
    navigate('/login');
  }

  return (<NavbartopView
    handleLogout={handleLogout}
    navigateAdministration={navigateAdministration}
    navigateChantier={navigateChantier}
    navigateAjouter={navigateAjouter}
    navigateCheckin={navigateCheckin}
    navigateAccueil={navigateAccueil}
    navigateHistorique={navigateHistorique}
    navigateLogin={navigateLogin}/>
  );
}

export default Navbartop;
